import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { ApiService } from './api.service';
import { User, Etablissement, Pays, Civilite } from '../models';

@Injectable()
export class SigninService {

  constructor(
  	private apiService: ApiService
  ) { }

  getAllCivilites(): Observable<[Civilite]>{
  	return this.apiService.get('/civilite')
  		.map(data => data.civilite );
  }

  getAllPays(): Observable<[Pays]>{
    return this.apiService.get('/pays/B2B')
      .map(data => data.pays );
  }

  getFrancePays():Observable<[Pays]>{
    return this.apiService.get('/pays/B2C')
      .map(data => data.pays );
  }

  getPays(id: number): Observable<Pays>{
    return this.apiService.get('/pays/'+id)
      .map(data => data.pays );
  }

  getAllTypes():Observable<any>{
    return this.apiService.get('/typeUtilisateur')
      .map(data => data.typeUtilisateur );
  }

  checkUAI(uai:string): Observable<Etablissement>{
  	return this.apiService.get('/etablissement/'+uai)
  		.map(data => data.etablissement);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/signin.service.ts